import React, { useState, useEffect } from "react";
import { Modal, Box, TextField, Button, CircularProgress } from "@mui/material";
import { postJsonData } from "../../network/ApiController";
import ApiEndpoints from "../../network/ApiEndPoints";
import { apiErrorToast, okSuccessToast } from "../../utils/ToastUtil";
import { ddmmyy } from "../../utils/DateUtils";

const UpdateBiller = ({ open, handleClose, row, getBillers }) => {
  const [formData, setFormData] = useState({
    biller_name: "",
    param1: "",
    param2: "",
    param3: "",
  });
  const [loading, setLoading] = useState(false);

  // Set the initial data when the modal is opened
  useEffect(() => {
    if (open && row) {
      setFormData({
        biller_name: row.biller_name || "",
        param1: row.param1 || "",
        param2: row.param2 || "",
        param3: row.param3 || "",
      });
    }
  }, [open, row]);

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  // Handle form submission for updating biller
  const handleSubmit = () => {
    const today = new Date();
    const todayDate = today.toISOString().split("T")[0];

    const formatDate = (date) => {
      if (!date) {
        return null;
      }

      const dateParts = date.split("/");
      if (dateParts.length === 3) {
        const [day, month, year] = dateParts;

        if (day && month && year) {
          return `${year}-${month}-${day}`;
        }
      }

      console.warn("Invalid date format, falling back to null:", date);
      return null;
    };

    const data = {
      id: row.id,
      biller_name: formData.biller_name,
      param1: formData.param1,
      param2: formData.param2,
      param3: formData.param3,
      last_paid: formData.last_paid || null,
      due_date: formData.due_date,
    };

    postJsonData(
      ApiEndpoints.UPDATE_BILLER,
      data,
      setLoading,
      (res) => {
        okSuccessToast(res.data.message);
        getBillers();
        handleClose();
      },
      (error) => {
        apiErrorToast(error);
      }
    );
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="update-biller-modal"
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 400,
          bgcolor: "background.paper",
          borderRadius: 2,
          boxShadow: 24,
          p: 4,
        }}
      >
        <h2 id="update-biller-modal" style={{ marginBottom: "20px" }}>
          Update Biller
        </h2>
        <TextField
          label="Biller Name"
          name="biller_name"
          fullWidth
          value={formData.biller_name}
          onChange={handleChange}
          style={{ marginBottom: "16px" }}
        />
        <TextField
          label="Param 1"
          name="param1"
          fullWidth
          value={formData.param1}
          onChange={handleChange}
          style={{ marginBottom: "16px" }}
        />
        <TextField
          label="Param 2"
          name="param2"
          fullWidth
          value={formData.param2}
          onChange={handleChange}
          style={{ marginBottom: "16px" }}
        />
        <TextField
          label="Param 3/Amount"
          name="param3"
          fullWidth
          value={formData.param3}
          onChange={handleChange}
          style={{ marginBottom: "16px" }}
          disabled
        />

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Button
            variant="outlined"
            onClick={handleClose}
            disabled={loading}
            style={{ width: "45%" }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleSubmit}
            disabled={loading}
            style={{ width: "45%" }}
          >
            {loading ? <CircularProgress size={24} /> : "Update Biller"}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default UpdateBiller;
